module.exports = __webpack_public_path__ + "static/img/13.0155537.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/13.png
// module id = Ply/
// module chunks = 0